import { Fees, Section, Space } from '../../../../../../components/core-v2'
import { Fee } from '../../../../types'
import { StyledCharges } from '../../../01-note/existing-note/details-summary/primitives'
import { StyledChargesBlock } from '../../primitives'

export type Delta1EditorProps = {
  fees?: Fee[]
}

export function Delta1EditorDumb({ fees }: Delta1EditorProps) {
  return (
    <fieldset>
      {Array.isArray(fees) && (
        <Space mx={5} my={6}>
          <StyledChargesBlock>
            <Section type="secondary">
              <StyledCharges>
                <Fees fees={fees} title="Charges" />
              </StyledCharges>
            </Section>
          </StyledChargesBlock>
        </Space>
      )}
    </fieldset>
  )
}
